<template>
	<div class="page-in">
		<van-nav-bar
		  :title="$t(data.title)"
		  fixed
		  placeholder
		  left-arrow
		  z-index="99"
		  @click-left="back"
		  :border="false"
		  v-if="isMobileFlag"
		/>
		<div class="inside-page">
			<div class="layui-container">
				<div class="signle-panel">
					<h1 class="article-title">
						{{ data.title }}
					</h1>	
					<div class="article-content" v-html="data.content">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {index_notice_details_api} from '@/api/index'
	export default {
		data() {
			return {
				data:{}
			};
		},
		methods:{
			async getNotice(pageid) {
				let param = {
					id: pageid,
				};
			  const res = await index_notice_details_api(param);
			  if (res && res.data.code == 1) {
				this.data = res.data.data
			  }
			},
		},
		mounted() {
			const pageid = this.$route.query.pageid;
			if (pageid) {
			    this.getNotice(pageid);
			}
			
		}
	}
</script>
